export default __webpack_public_path__ + "static/media/2.6f37cbf8.jpg";